import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  setInfluencerRef,
  INFLUENCER_LANDING_URL,
  parseInfluencerCodeFromPathname,
} from '../utils/influencerAttribution';

/**
 * Entrada de rastreio: /r/:code (app ou site).
 * Grava o código (cookie .constelabrasil.com.br + localStorage) e redireciona para a landing.
 */
const InfluencerRedirect: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const normalized = parseInfluencerCodeFromPathname(location.pathname);
    if (normalized) {
      setInfluencerRef(normalized);
    }
    const target = normalized
      ? `${INFLUENCER_LANDING_URL}?ref=${encodeURIComponent(normalized)}`
      : INFLUENCER_LANDING_URL;
    window.location.replace(target);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#EAF4F2] text-[#4A7C75]">
      <p className="text-lg font-medium">Redirecionando...</p>
    </div>
  );
};

export default InfluencerRedirect;
